export default {
  register: {
    value: 'register',
    label: '产品注册卡',
  },
  warranty: {
    value: 'warranty',
    label: '延保卡',
  },
}